import { Promo } from '../models/promo';

export const PROMO_LIST: Promo[] = [
  {
    name: 'vps',
    status: 3,
    title: 'contests-vps.title',
    description: 'contests-vps.subtitle',
    type: 1,
    sort_weight: 99,
  }
];
